export default {
  'UPDATE_SETTINGS'(state, data) {
    state.settings = data;
  },
  'UPDATE_USER_DATA'(state, data) {
    state.userData = data;
  },
  'UPDATE_DIRECTORIES'(state, data) {
    state.directories = data;
  },
  'UPDATE_CURRENCIES_LIST'(state, data) {
    state.currencies = data;
  },
  'SET_USER_BOOKMAKERS'(state, data) {
    state.userBookmakers = data;
  },
  'SET_SCANNER_PAGE_TYPE'(state, data) {
    state.scannerPageType = data;
  },
  'SET_SCANNER_PAGE_NAME'(state, data) {
    state.scannerPageName = data;
  },
  'UPDATE_INTERFACE_ZOOM'(state, data) {
    state.interfaceZoom = data;
  },
  'UPDATE_COUNTRIES_LIST'(state, data) {
    state.countriesList = data;
  },
  'UPDATE_LEAGUES_LIST'(state, data) {
    state.leaguesList = data;
  },
  'UPDATE_SIDEBAR_HEIGHT'(state, data) {
    state.sidebarHeight = data;
  },
  'UPDATE_HEADER_SEARCH_QUERY'(state, data) {
    state.headerSearchQuery = data;
  },
  'SET_GLOBAL_LOAD_ERROR'(state, data = 'Loading Error') {
    state.globalLoadError = data;
  },
  'SET_GLOBAL_LOAD_WARNING'(state, data ) {
    state.globalLoadWarning = data;
  },
  'SET_ARBS_FORMULAS_LIST'(state, data) {
    state.arbsFormulas = data;
  },
  'SET_DEFAULT_FILTER_REQUEST_PARAMS'(state, data) {
    state.defaultFilterRequestParams = data;
  },
  'UPDATE_ONBOARDING'(state, data) {
    state.userData.show_onboarding = data;
  },
  'TOGGLE_STATUS_WIDGET_STATE'(state, data) {
    state.statusWidgetCollapsed = data;
  },
  'SET_NEW_UNREAD_STATUS_STATE'(state, data) {
    state.newUnreadStatus = data;
  },
  'SET_NUMBER_OF_UNREAD_STATUS'(state, data) {
    state.numberOfUnreadStatus = data;
  },
  'SET_PREV_KOEF_FORMAT_STATE'(state, data) {
    state.prevKoefFormat = data;
  },
  'TOGGLE_HINTS'(state, data) {
    state.showHints = data;
  },
  'UPDATE_USER_BOOKMAKERS'(state, data) {
    const index = state.userBookmakers.bookmakers.findIndex((object) => {
      return object.bookmaker_id === data.outcomeId;
    });
    const cloneIndex = state.userBookmakers.clones.findIndex((object) => {
      return object.bookmaker_id === data.outcomeId;
    });
    if (index !== -1) {
      state.userBookmakers.bookmakers[index].currency_id = data.currencyId;
    }
    if (cloneIndex !== -1) {
      state.userBookmakers.clones[cloneIndex].currency_id = data.currencyId;
    }
  },
  'SET_PERCENT_VALUE'(state, value) {
    state.percentValue = value;
  },
};
